// Only presentation changes: permissions, routes and stored teams remain intact.
export function conversationMenu(items) {
  return items.filter(item => item.name !== 'Inbox').map(item => item.name === 'Conversation'
    ? { ...item, children: item.children.filter(child => ['All', 'Channels'].includes(child.name)) }
    : item);
}
